import { ActivityTask, ActivityTaskInstance } from './../../../model/SolutionInfo';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Activity, ActivityTaskHost } from 'src/app/model/SolutionInfo';
import { ActivityService } from 'src/app/service/activity.service';
import { EventService } from 'src/app/service/event.service';
import { Events } from 'src/app/service/websocket.service';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { ColumnType, DataTableColumn, DataTableRow } from '../../controls/datatable/datatable.component';
import { TaskStatus } from 'src/app/model/TaskStatus';

@Component({
    selector: 'app-activity-system-task-details',
    templateUrl: './activity-system-task-details.component.html',
    styleUrls: ['./activity-system-task-details.component.css'],
    standalone: false
})
export class ActivitySystemTaskDetailsComponent implements OnInit {

  minheight:string;
  height:string = '400px';
  hostName:string;
  hostAddress:string;
  path:string;
  currentActivity:Activity;
  eventMessageSubscription: Subscription;

  taskCol: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("taskName", $localize`Task name`, ColumnType.STRING, true, "35"),
    new DataTableColumn("message", $localize`Message`, ColumnType.STRING, false, "55"),
    new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "10"),);
  taskRow: DataTableRow[] = [];
  
  constructor(private modalConfig: ModalConfig, private modalRef: ModalRef,
              private eventService: EventService, private activityService:ActivityService) {
    this.hostName = this.modalConfig.data.hostName;
    this.path = this.modalConfig.data.path;
    this.hostAddress = this.modalConfig.data.hostAddress;
    this.currentActivity = this.modalConfig.data.activity;
   }

  ngOnInit(): void {
    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.ActivityTaskStatus){
        let data:any = msg.body;

        if(data.activityId == this.currentActivity.id &&
          data.hostAddress == this.hostAddress){
            if(data.instancePath && data.instancePath != ''){

            }else{

            }
          let isMsgReceived:boolean = (data.instancePath === undefined) ||
                                      (data.instancePath && data.instancePath != '' && data.instancePath == this.path);

          if(isMsgReceived){
            let row:DataTableRow[] =this.taskRow.filter((row:DataTableRow) => {
              return row.data.type == data.taskType;
            });

            if(row.length > 0){
              row[0].data.message = data.message ? data.message : '';
            }
          }
        }
      }else if(msg.eventType == Events.ActivityRefresh){
        if(msg.body.id == this.currentActivity.id){
          this.activityService.getActivityById(this.currentActivity.id).pipe(
            tap(resp => {
              this.currentActivity = resp.body;
              this.currentActivity.isRunning = this.currentActivity.status === 'RUNNING';
              this.init();
            })).subscribe();
        }
      }
    });
    this.init();
  }

  ngOnDestroy(){
    this.eventMessageSubscription.unsubscribe();
  }

  init(){
    let instance:ActivityTaskInstance = this.getInstance();

    if(instance){
      this.taskRow = [];
      instance.tasks.forEach((task:ActivityTask) => {
        let msg:string = "";

        if(this.currentActivity.isRunning || (task.completed && task.success)){
          msg = task.statusMessage ? task.statusMessage : '';
        }else if(task.completed && !task.success){
          msg = task.errorMessage ? task.errorMessage : '';
        }

        task.taskName = ActivitySystemTaskDetailsComponent.getTaskName(task.type);
        this.taskRow.push((new DataTableRow({taskName: task.taskName, message: msg, type:task.type,
                                             status: ActivitySystemTaskDetailsComponent.getTaskStatus(task, this.currentActivity.isRunning)}, [])))
      });
    }
  }

  getTitle():string{
    return $localize `${this.hostName} (${this.path}) instance details`;
  }

  close():void {
    this.modalRef.close();
  }

  static getTaskName(type:string): string {
    let name:string;

    switch(type) { 
      case 'DOWNLOAD_PACKAGES': { 
         name = $localize`Download required packages`;
         break; 
      } 
      case 'INSTALL_REDISTRIBUTABLES': { 
        name = $localize`Install redistributables`;
        break; 
      }
      case 'GET_SERVICE_INFO': { 
        name = $localize`Get services information`;
        break; 
      }
      case 'STOP_SERVICES': { 
        name = $localize`Stop services`;
        break; 
      }
      case 'INSTALL_PATCH': { 
        name = $localize`Install updates`;
        break; 
      }
      case 'START_MASTER_SYSTEM_AND_REGISTERED_ADMIN_SERVERS': { 
        name = $localize`Start primary system and Admin servers`;
        break; 
      }
      case 'DB_UPGRADE': { 
        name = $localize`Database upgrade`;
        break; 
      }
      case 'START_REMAINING_SERVICES': { 
        name = $localize`Start remaining services`;
        break; 
      }
      case 'INCREMENT_RESOURCES': { 
        name = $localize`Increment resource identifier`;
        break; 
      }
      case 'PRODUCT_ANALYSIS': { 
        name = $localize`Product Analysis`;
        break; 
      }
      case 'REGISTER_PRODUCT_ENABLEMENT': { 
        name = $localize`Update product information`;
        break; 
      }
      case 'VALIDATE_CURRENT_INSTALL': {
        name = $localize`Validate current installation`;
        break;
      }
      case 'START_SERVICES': {
        name = $localize`Start services`;
        break;  
      }
      case 'VALIDATE_HOST': {
        name = $localize`Validate host`;
        break;
      }
      case 'VALIDATE_COMMUNICATIONS': {
        name = $localize`Validate communications`;
        break;
      }
      case 'SOFTWARE_ROLLBACK': {
        name = $localize`Software rollback`;
        break;
      }
      case 'INI_UPGRADE': {
        name = $localize`Upgrade unused services`;
        break;
      }
      case 'VALIDATE_PATCHED_SYSTEM': {
        name = $localize`Validate patched system`;
        break;
      }
      case 'PACKAGE_AGENT_LOGS': {
        name = $localize`Package agent logs`;
        break;
      }
      case 'PACKAGE_MANAGER_LOGS': {
        name = $localize`Package manager logs`;
        break;
      }
      case 'CREATE_LOGS_PACKAGE': {
        name = $localize`Create logs package`;
        break;
      }
      case 'PREPARE_ENVIRONMENT': {
        name = $localize`Prepare environment`;
        break;
      }
      case 'VALIDATE_PROD_LOGS_DIRECTORY_PERM': {
        name = $localize`Verify product logs directory permission`;
        break;
      }
      case 'VALIDATE_PROD_LOGS_DISKSPACE': {
        name = $localize`Check diskspace for Product Logs Package`;
        break;
      }
      case 'PACKAGE_PROD_LOGS': {
        name = $localize`Package product logs`;
        break;
      }
      case 'CREATE_PROD_LOGS_PACKAGE': {
        name = $localize`Create Product Logs Package`;
        break;
      }
      case 'AGENT_SYS_REPORT': {
        name = $localize`Get agent system report`;
        break;
      }
      case 'CREATE_SYS_REPORT': {
        name = $localize`Generate system report`;
        break;
      }
      case 'PING': {
        name = $localize`Ping`;
        break;
      }
      case 'ADMIN_SETTINGS': {
        name = $localize`Apply Administration Settings`;
        break;
      }
      case 'RESTART_CS_SERVICE': {
        name = $localize`Restart Content Server Service`;
        break;
      }
      case 'START_PRIMARY_SYSTEM': {
        name = $localize`Start primary system`;
        break;  
      }
      case 'BACKUP_APPLICATION_DATA': {
        name = $localize`Backup application data`;
        break;
      }
      case 'REMOVE_APPLICATION_DATA': {
        name = $localize`Remove application data`;
        break;
      }
      case 'UPDATE_PRIMARY_APPLICATION': {
        name = $localize`Update primary application`;
        break;
      }
      case 'UPDATE_SECONDARY_APPLICATIONS': {
        name = $localize`Update secondary applications`;
        break;
      }
      case 'EXPORT_DATABASE': {
        name = $localize`Export database`;
        break;
      }
      case 'COLLECT_PROD_LOGS_PACKAGE': {
        name = $localize`Collect product log packages`;
        break;
      }
      case 'GENERATE_CORE_REPORT': {
        name = $localize`Generate core report`;
        break;
      }
      case 'REMOVE_PATCHES': {
        name = $localize`Remove patches`;
        break;
      }
      default: { 
        name = type;
        break; 
     } 
   }

   return name;
  }

  static getTaskStatus(task:TaskStatus, isRunning:boolean): any {
    let status:any;

    if(task.completed && task.success){
      if(!task.ignored){
        status = {className: 'otsc-icon-status-success', altText: $localize`Completed`};
      }else{
        status = {className: 'otsc-icon-status-ignore', altText: $localize`Skipped`};
      }
    }else if(task.completed && !task.success){
      status = {className: 'otsc-icon-status-error', altText: $localize`Complete with errors`} ;
    }else if(isRunning){
      status = {className: 'otsc-icon-status-loading-spinner', altText: $localize`Running...` }
    }else{
      status = {className: '', altText: $localize`` }
    }

    return status;
  }

  private getInstance(): ActivityTaskInstance {
    let instance:ActivityTaskInstance[] = [];

    let host:ActivityTaskHost[] = this.currentActivity.hostTasks.filter((host:ActivityTaskHost) => {
      return host.macAddress == this.hostAddress;
    });

    if(host.length > 0){
      instance = host[0].instances.filter((instance:ActivityTaskInstance) => {
        return instance.path == this.path;
      });
    }

    return instance.length > 0 ? instance[0]: undefined;
  }
}
